import { ServiceIdentifier } from '../service-locator';
import { SettingsService } from './interfaces';

export * from './constants';
export * from './interfaces';

/**
 * The service locator identifier for the SettingsService
 */
export const SETTINGS_SERVICE = ServiceIdentifier.get<SettingsService>('SettingsService');
